import React, { Suspense } from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { errorHandling } from './errorHandling';

const LazyTrainingMenu = React.lazy(() => import('Products/TrainingMenu').catch(errorHandling));

const TrainingMenuLoader = () => (
    <ErrorBoundary fallback={<></>}>
        <Suspense fallback={<div></div>}>
            <LazyTrainingMenu />
        </Suspense>
    </ErrorBoundary>
);

export default TrainingMenuLoader;
